import Vue from 'vue'
import firebase from 'firebase/app'
import 'firebase/auth';
import Router from 'vue-router'
import Login from './views/Login.vue'
import Home from './views/Home.vue'
import Vizsgak from './views/Vizsgak.vue'
import Diakok from './views/Diakok.vue'
import Tanfolyamok from './views/Tanfolyamok.vue'
import Setup from './views/Setup.vue'
import Lessons from './views/Lessons.vue'
import Oktatok from './views/Oktatok.vue'
import Orvosi from './views/Orvosi.vue'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Diakok,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/vizsgak',
      name: 'vizsgak',
      component: Vizsgak
    },
    {
      path: '/diakok',
      name: 'diakok',
      component: Diakok,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/uzenofal',
      name: 'uzenofal',
      component: Home,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/tanfolyamok',
      name: 'tanfolyamok',
      component: Tanfolyamok,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/orarend',
      name: 'orarend',
      component: Lessons,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/oktatok',
      name: 'oktatok',
      component: Oktatok,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/orvosi',
      name: 'orvosi',
      component: Orvosi,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/setup',
      name: 'setup',
      component: Setup,
      beforeEnter(to, from, next) {
        if (store.state.auth.user_mail == 'vizsga@csigaver.hu') {
          next('vizsgak')
        } else {
          next();
        }
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  var user = firebase.auth().currentUser
  if (user) {
    store.state.auth.user_mail = user.email;  
  }
  if (!user && to.path !== '/login') next('login')
  else next()
})

export default router
